// extracted by mini-css-extract-plugin
export default {"container":"bLKi-","text":"_1pXr9"};